<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	Move Contact
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
		<div fxFlex>
			<div fxFlex>Name:</div>
			<div fxFlex>{{data.carrier.businessName}}</div>
		</div>
		<div fxFlex>
			<div fxFlex>MC:</div>
			<div fxFlex>{{data.carrier.mc}}</div>
		</div>
	</div>

	<div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 1rem">
		<mat-form-field fxFlex="100">
			<input [(ngModel)]="mc" matInput placeholder="Enter MC for new carrier" type="text" />
		</mat-form-field>
	</div>
</mat-dialog-content>

<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div fxFlex="100" fxLayoutAlign="end end">
		<button (click)="closeDialog()" mat-raised-button>Cancel</button>
		<button
			(click)="moveContact()"
			*ngIf="!isRequestInProgress"
			[disabled]="mc.length == 0"
			color="primary"
			mat-raised-button
		>
			Update
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
